import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import LabelInfo from '../../../../../components/LabelInfo';
import { setNumberWithComma } from '../../../../../lib/common';
import './OrderExchangeListSummaryBox.scss';

const OrderExchangeListSummaryBox = (props) => {
  const { orderExchangeSummaryBox } = props;

  return (
    <Panel className="order-exchange-list-summary-box">
      <div className="panel-body">
        <div className="order-exchange-list-summary-box-info">
          <div className="form-wrap">
            <LabelInfo
              label="교환 요청 건수"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeRequestCnt, '건')}
            />

            <LabelInfo
              label="교환 요청 합계 금액"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeRequestTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="교환 수거 완료 건수"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeReceiveCnt, '건')}
            />

            <LabelInfo
              label="교환 수거 완료 금액"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeReceiveTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="교환 처리 지연 건수"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeDelayCnt, '건')}
            />

            <LabelInfo
              label="교환 처리 지연 금액"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeDelayTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="교환 거부 건수"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeRejectCnt, '건')}
            />

            <LabelInfo
              label="교환 거부 합계 금액"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeRejectTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="재배송중 건수"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeDispatchCnt, '건')}
            />

            <LabelInfo
              label="재배송중 합계 금액"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeDispatchTotalPrice, '원')}
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="교환 완료 건수"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeCompleteCnt, '건')}
            />

            <LabelInfo
              label="교환 완료 합계 금액"
              info={setNumberWithComma(orderExchangeSummaryBox.exchangeCompleteTotalPrice, '원')}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default OrderExchangeListSummaryBox;
